export default {
  0: '未知',
  1: '男',
  2: '女'
}
